import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import "react-bootstrap-typeahead/css/Typeahead.css";
import {
    MDBBadge, MDBListGroup, MDBListGroupItem, MDBIcon, MDBBtn, MDBInput
    , MDBDatatable,MDBTooltip
} from 'mdb-react-ui-kit';
import ErrorDialog from './errordialog';
import services from "../../helper/services";
import moment from 'moment';
import { socket } from "../../helper/socket";

import { useSelector } from "react-redux";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AdapterDateFnsBuddhist from '../../helper/date-fns-be';
import { th, enUS } from 'date-fns/locale';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Historypersonalhealthgroup from './historypersonalhealthgroup'
import Confirmmodal from './confirmmodal'
import Resultmodal from './resultmodal'
import Dropdown from "./dropdown";

const component = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const error = useRef();
    const confirm = useRef();
    const detail = useRef();
    const department = useRef();
    const form = useRef();
    const [urgentcolor] = useState(["", "success", "warning", "danger"]);
    const { t } = useTranslation('translations');
    const [wait, setWait] = useState(false);
    const [result, setResult] = useState([]);

    const [value, setValue] = useState(new Date(moment().add(-1, 'd').format("YYYY-MM-DD")));
    const [value2, setValue2] = useState(new Date(moment().add(1, 'd').format("YYYY-MM-DD")));
    const dateAdapter = useSelector(state => state.lang);
    const [notiMessage, setNotiMessage] = useState({});

    function handleChange(newValue) {
        setValue(newValue)

    }
    function handleChange2(newValue2) {
        setValue2(newValue2)

    }

    useImperativeHandle(ref, () => ({
        updateList: (newitem) => {
            form?.current?.requestSubmit();


        }
    }))
    async function updatestatus(msg) {
        var updatedresult = await services.searchResult({
            dateFromSearch: moment(value).format('YYYY-MM-DD'),
            dateToSearch: moment(value2).format('YYYY-MM-DD')
            , checkup: props.checkup, id: msg.id
        }, "admin");
        if (updatedresult?.length > 0) {
            var newresult = result.map((x) => (x.result_id === updatedresult[0].result_id ? { ...updatedresult[0] } : x));
            setResult(newresult);
        }

    }

    useEffect(() => {
        if (notiMessage.flag) {
            if (notiMessage.flag == "updatestatus") {
                updatestatus(notiMessage.msg);
            }
            setNotiMessage({});
        }
    }, [notiMessage]);

    async function getHistory(data) {
        if (wait) return;
        setWait(true);
        try {
            var result = await services.searchResult(data, "admin");
            for (const item of result) {
                try {
                    //item.logic_result = JSON.parse(item.logic_result);
                    item.urgency = item.logic_result.urgency;
                } catch (ex) { }
            }
            setResult(result);
            setWait(false);

        } catch (e) {
            setWait(false);
            error.current.showerror(e);
        }

    }

    async function handleSubmit(e) {
        var errormessage = "";
        e.preventDefault();
        var form = (new FormData(e.target));
        getHistory({
            tel: form.get("search_tel"),
            email: form.get("search_email"),
            department: department?.current?.getResult()?.value ?? null,
            dateFromSearch: moment(value).format('YYYY-MM-DD'),
            dateToSearch: moment(value2).format('YYYY-MM-DD')
            , checkup: props.checkup
        });
    }

    async function handleclick(row) {
        confirm.current.openModal(async (comment) => {
            await services.updateResult(row.result_id, (props.checkup == "Y" ? "C" : "S"), "confirm", { commentlist: comment["confirmcheck"], comment: comment["item_other_confirmcheck"] });
            /*             var newresult = result.map((x) => (x.id === row.id ? { ...x, confirm: 1 } : x));
            
                        setResult(newresult); */
        })
    }

    async function handledetailclick(row) {
        if (!row.commentobj) {
            const confirm_detail = await services.getconfirmdetail(row.result_id, (props.checkup == "Y" ? "C" : "S"));
            row.commentobj = {
                confirm_comment: {
                    confirmcheck: confirm_detail.map(el => el.value)
                    , "item_other_confirmcheck": row.confirm_comment
                }
            }
        }

        detail.current.openModal({
            ...row,
            ...row.commentobj
        })
    }
    useEffect(() => {
        socket.on('updatestatus', (msg) => {
            setNotiMessage({ flag: "updatestatus", msg: msg })
        });

        getHistory({
            dateFromSearch: moment(value).format('YYYY-MM-DD'),
            dateToSearch: moment(value2).format('YYYY-MM-DD')
            , checkup: props.checkup
        });


    }, []);

    async function handlenavigateclick(row) {
        await services.updateResult(row.result_id, (props.checkup == "Y" ? "C" : "S"), "acknowledge");
        navigate((row.onepage !== "Y" ? "/checkupresult/" : "/result/") + row.result_id, { state: { hasPrevious: "Y", previous: "/admin/history", contact: "N", given_name: row.given_name, family_name: row.family_name } });
    }

    function generateTree(obj) {
        var main = obj.map((row) => {
            return {
                ...row,
                topic_note: (
                    <MDBTooltip tag='a' title={t(row["topic_note"])}>
                        {t(row["topic_note"])}
                        </MDBTooltip >
                ),
                createtime: (
                    <>
                        {t("resultdatetime", {
                            val: new Date(row["createtime"]), formatParams: {

                                val: {
                                    lng: (dateAdapter == "th" ? "th" : "en-GB"),
                                    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit',
                                    minute: '2-digit',
                                },
                            }
                        })}
                    </>
                ),
                gender: (row.gender == "M" ? t("Male") : t("Female")),
                self_exam: (row.self_exam == "Y" ? t("Yes") : t("no_v2")),
                resultaction: (<>
                    <MDBBtn outline size='sm' floating color='info' onClick={() => handlenavigateclick(row)}>
                        <MDBIcon fas icon="angle-right" />
                    </MDBBtn>
                </>),
                called: (<>
                    {row.acknowledge && <MDBBtn onClick={() => handledetailclick(row)} outline size='sm' floating color="secondary" ><MDBIcon far icon={(row.acknowledge ? "check-" : "") + `circle`} size='2x' color={(row.acknowledge ? "info" : "secondary")} /></MDBBtn>}
                </>),
                confirmed: (<>
                    {row.confirm && <MDBBtn onClick={() => handledetailclick(row)} outline size='sm' floating color="secondary" ><MDBIcon far icon={(row.confirm ? "check-" : "") + `circle`} size='2x' color="info" /></MDBBtn>}
                    {!row.confirm && <MDBBtn onClick={() => handleclick(row)} outline size='sm' floating color={(row.confirm ? "info" : "secondary")} ><MDBIcon far icon={(row.confirm ? "check-" : "") + `circle`} size='2x' color={(row.confirm ? "info" : "secondary")} /></MDBBtn>}
                </>)

            };
        });

        var resultData = {
            columns: [
                { label: t("called"), field: 'called', sort: false  },
                { label: t("confirmed"), field: 'confirmed', sort: false  },
                { label: t('Result Date'), field: 'createtime', sort: false  },
                { label: t("Topic"), field: 'topic_note' , sort: false },
                { label: t("Telephone"), field: 'tel', sort: false  },
                { label: t("Email"), field: 'email', sort: false  },
                { label: t("Name"), field: 'given_name', sort: false  },
                { label: t("Surname"), field: 'family_name', sort: false  },
                { label: t("age"), field: 'age', sort: false  },
                { label: t("gender"), field: 'gender', sort: false  },
                { label: t("Self Exam"), field: 'self_exam' , sort: false },


            ],
            rows: main
        }
        /*         if (props.checkup == "N")
                    resultData.columns.push({ label: t("urgencylevel"), field: 'urgencylevel' }) */

        resultData.columns = [...resultData.columns,
        { label: t("Open Result"), field: 'resultaction' }]

        //var items = group_time(obj);
        return <>
            <MDBDatatable hover data={resultData} sortField='createtime' sortOrder='desc' rowsText={t("Rows per page:")} />
        </>

    }

    return (

        <div className="container-fluid">
            <ErrorDialog ref={error} />
            <Confirmmodal ref={confirm} remark="confirmcheck" />
            <Resultmodal ref={detail} remark="confirmcheck" />
            {<form ref={form} onSubmit={(e) => handleSubmit(e)}>
                < div className="row">
                    {/*     <div className="col"> <Dropdown label={("department")} list="department" ref={department} size="lg" /></div> */}
                    <div className="col"><MDBInput wrapperClass='h-100' label={t('Enter Email')} id='search_email' name="search_email" /></div>
                    <div className="col"><MDBInput wrapperClass='h-100' label={t('Enter Tel')} id='search_tel' name="search_tel" /></div>

                    {dateAdapter !== "th" && <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS} >

                        <div className="col"><DesktopDatePicker

                            minDate={new Date(((new Date().getFullYear()) - 150).toString() + '-01-01')}
                            maxDate={new Date()}
                            onChange={handleChange}
                            value={value}
                            slotProps={{ textField: { sx: { width: "100%" }, variant: 'outlined', size: 'small', id: "datefrom" } }}

                            format="dd MMM yyyy"
                        /></div>
                        <div className="col"><DesktopDatePicker

                            minDate={new Date(((new Date().getFullYear()) - 150).toString() + '-01-01')}
                            maxDate={new Date(moment().add(1, 'd').format("YYYY-MM-DD"))}
                            onChange={handleChange2}
                            value={value2}
                            slotProps={{ textField: { sx: { width: "100%" }, variant: 'outlined', size: 'small', id: "dateto" } }}

                            format="dd MMM yyyy"
                        />
                        </div>

                    </LocalizationProvider>}
                    {dateAdapter == "th" && <LocalizationProvider dateAdapter={AdapterDateFnsBuddhist} adapterLocale={th} >

                        <div className="col"><DesktopDatePicker

                            minDate={new Date(((new Date().getFullYear()) - 150).toString() + '-01-01')}
                            maxDate={new Date()}
                            onChange={handleChange}
                            value={value}
                            slotProps={{ textField: { sx: { width: "100%" }, variant: 'outlined', size: 'small', id: "datefrom" } }}

                            format="dd MMM yyyy"
                        /></div>
                        <div className="col"><DesktopDatePicker

                            minDate={new Date(((new Date().getFullYear()) - 150).toString() + '-01-01')}
                            maxDate={new Date(moment().add(1, 'd').format("YYYY-MM-DD"))}
                            onChange={handleChange2}
                            value={value2}
                            slotProps={{ textField: { sx: { width: "100%" }, variant: 'outlined', size: 'small', id: "dateto" } }}

                            format="dd MMM yyyy"
                        />
                        </div>

                    </LocalizationProvider>}
                    <div className="col">
                        <MDBBtn className='me-1' color='info' type="submit" disabled={wait}>
                            {t("search")}
                        </MDBBtn>
                    </div>
                </div>
            </form>
            }
            {result.length > 0 && <>

                <div className="pt-4">
                    {generateTree(result)}
                </div>


            </>}
        </div>
    );
});



export default component;